var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2384_121675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.2998V9.71362C11.9994 9.94186 11.8145 10.1267 11.5862 10.1273H0.413818C0.185486 10.1267 0.00064087 9.94186 0 9.71362V9.2998H12Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.26538V9.29984H0V2.26538C0.00064087 2.03705 0.185486 1.8522 0.413818 1.85156H11.5862C11.8145 1.8522 11.9994 2.03714 12 2.26538Z",
    fill: "#C03A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413818 1.85156H5.79309V5.98947H0V2.26538C0 2.03687 0.185211 1.85156 0.413818 1.85156Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79309 2.6792H12V3.50674H5.79309V2.6792Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79309 4.33423H12V5.16187H5.79309V4.33423Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.9895H12V6.81714H0V5.9895Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51447 8.47217H12V7.64453H0V8.47217H4.48553",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413757 2.05835L0.509705 2.25262L0.724121 2.28384L0.568939 2.43509L0.60556 2.64859L0.413757 2.54788L0.221954 2.64859L0.258575 2.43509L0.103394 2.28384L0.317719 2.25262L0.413757 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24127 2.05835L1.33731 2.25262L1.55164 2.28384L1.39645 2.43509L1.43307 2.64859L1.24127 2.54788L1.04947 2.64859L1.08609 2.43509L0.930908 2.28384L1.14532 2.25262L1.24127 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06891 2.05835L2.16486 2.25262L2.37918 2.28384L2.22409 2.43509L2.26071 2.64859L2.06891 2.54788L1.87711 2.64859L1.91373 2.43509L1.75854 2.28384L1.97287 2.25262L2.06891 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89642 2.05835L2.99246 2.25262L3.20679 2.28384L3.05161 2.43509L3.08823 2.64859L2.89642 2.54788L2.70462 2.64859L2.74124 2.43509L2.58606 2.28384L2.80038 2.25262L2.89642 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72418 2.05835L3.82013 2.25262L4.03445 2.28384L3.87927 2.43509L3.91589 2.64859L3.72418 2.54788L3.53238 2.64859L3.569 2.43509L3.41382 2.28384L3.62814 2.25262L3.72418 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5517 2.05835L4.64774 2.25262L4.86206 2.28384L4.70688 2.43509L4.7435 2.64859L4.5517 2.54788L4.35989 2.64859L4.39651 2.43509L4.24133 2.28384L4.45566 2.25262L4.5517 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37924 2.05835L5.47528 2.25262L5.68961 2.28384L5.53442 2.43509L5.57104 2.64859L5.37924 2.54788L5.18753 2.64859L5.22415 2.43509L5.06897 2.28384L5.28329 2.25262L5.37924 2.05835Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.879242 2.8418L0.975281 3.03607L1.18961 3.06729L1.03442 3.21854L1.07104 3.43204L0.879242 3.33115L0.687531 3.43204L0.724152 3.21854L0.56897 3.06729L0.783295 3.03607L0.879242 2.8418Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70685 2.8418L1.80289 3.03607L2.01721 3.06729L1.86203 3.21854L1.89865 3.43204L1.70685 3.33115L1.51505 3.43204L1.55167 3.21854L1.39648 3.06729L1.61081 3.03607L1.70685 2.8418Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53439 2.8418L2.63043 3.03607L2.84476 3.06729L2.68958 3.21854L2.7262 3.43204L2.53439 3.33115L2.34259 3.43204L2.37921 3.21854L2.22412 3.06729L2.43845 3.03607L2.53439 2.8418Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.362 2.8418L3.45795 3.03607L3.67236 3.06729L3.51718 3.21854L3.5538 3.43204L3.362 3.33115L3.1702 3.43204L3.20682 3.21854L3.05164 3.06729L3.26596 3.03607L3.362 2.8418Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18951 2.8418L4.28555 3.03607L4.49988 3.06729L4.3447 3.21854L4.38132 3.43204L4.18951 3.33115L3.99771 3.43204L4.03433 3.21854L3.87915 3.06729L4.09357 3.03607L4.18951 2.8418Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01727 2.8418L5.11322 3.03607L5.32755 3.06729L5.17245 3.21854L5.20908 3.43204L5.01727 3.33115L4.82547 3.43204L4.86209 3.21854L4.70691 3.06729L4.92123 3.03607L5.01727 2.8418Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413757 3.62524L0.509705 3.8197L0.724121 3.85074L0.568939 4.00198L0.60556 4.21567L0.413757 4.11478L0.221954 4.21567L0.258575 4.00198L0.103394 3.85074L0.317719 3.8197L0.413757 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24127 3.62524L1.33731 3.8197L1.55164 3.85074L1.39645 4.00198L1.43307 4.21567L1.24127 4.11478L1.04947 4.21567L1.08609 4.00198L0.930908 3.85074L1.14532 3.8197L1.24127 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06891 3.62524L2.16486 3.8197L2.37918 3.85074L2.22409 4.00198L2.26071 4.21567L2.06891 4.11478L1.87711 4.21567L1.91373 4.00198L1.75854 3.85074L1.97287 3.8197L2.06891 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89642 3.62524L2.99246 3.8197L3.20679 3.85074L3.05161 4.00198L3.08823 4.21567L2.89642 4.11478L2.70462 4.21567L2.74124 4.00198L2.58606 3.85074L2.80038 3.8197L2.89642 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72418 3.62524L3.82013 3.8197L4.03445 3.85074L3.87927 4.00198L3.91589 4.21567L3.72418 4.11478L3.53238 4.21567L3.569 4.00198L3.41382 3.85074L3.62814 3.8197L3.72418 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5517 3.62524L4.64774 3.8197L4.86206 3.85074L4.70688 4.00198L4.7435 4.21567L4.5517 4.11478L4.35989 4.21567L4.39651 4.00198L4.24133 3.85074L4.45566 3.8197L4.5517 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37924 3.62524L5.47528 3.8197L5.68961 3.85074L5.53442 4.00198L5.57104 4.21567L5.37924 4.11478L5.18753 4.21567L5.22415 4.00198L5.06897 3.85074L5.28329 3.8197L5.37924 3.62524Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413757 5.19214L0.509705 5.38641L0.724121 5.41763L0.568939 5.56888L0.60556 5.78238L0.413757 5.68167L0.221954 5.78238L0.258575 5.56888L0.103394 5.41763L0.317719 5.38641L0.413757 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24127 5.19214L1.33731 5.38641L1.55164 5.41763L1.39645 5.56888L1.43307 5.78238L1.24127 5.68167L1.04947 5.78238L1.08609 5.56888L0.930908 5.41763L1.14532 5.38641L1.24127 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06891 5.19214L2.16486 5.38641L2.37918 5.41763L2.22409 5.56888L2.26071 5.78238L2.06891 5.68167L1.87711 5.78238L1.91373 5.56888L1.75854 5.41763L1.97287 5.38641L2.06891 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89642 5.19214L2.99246 5.38641L3.20679 5.41763L3.05161 5.56888L3.08823 5.78238L2.89642 5.68167L2.70462 5.78238L2.74124 5.56888L2.58606 5.41763L2.80038 5.38641L2.89642 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72418 5.19214L3.82013 5.38641L4.03445 5.41763L3.87927 5.56888L3.91589 5.78238L3.72418 5.68167L3.53238 5.78238L3.569 5.56888L3.41382 5.41763L3.62814 5.38641L3.72418 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5517 5.19214L4.64774 5.38641L4.86206 5.41763L4.70688 5.56888L4.7435 5.78238L4.5517 5.68167L4.35989 5.78238L4.39651 5.56888L4.24133 5.41763L4.45566 5.38641L4.5517 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37924 5.19214L5.47528 5.38641L5.68961 5.41763L5.53442 5.56888L5.57104 5.78238L5.37924 5.68167L5.18753 5.78238L5.22415 5.56888L5.06897 5.41763L5.28329 5.38641L5.37924 5.19214Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.879242 4.40869L0.975281 4.60297L1.18961 4.63419L1.03442 4.78543L1.07104 4.99893L0.879242 4.89822L0.687531 4.99893L0.724152 4.78543L0.56897 4.63419L0.783295 4.60297L0.879242 4.40869Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70685 4.40869L1.80289 4.60297L2.01721 4.63419L1.86203 4.78543L1.89865 4.99893L1.70685 4.89822L1.51505 4.99893L1.55167 4.78543L1.39648 4.63419L1.61081 4.60297L1.70685 4.40869Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53439 4.40869L2.63043 4.60297L2.84476 4.63419L2.68958 4.78543L2.7262 4.99893L2.53439 4.89822L2.34259 4.99893L2.37921 4.78543L2.22412 4.63419L2.43845 4.60297L2.53439 4.40869Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.362 4.40869L3.45795 4.60297L3.67236 4.63419L3.51718 4.78543L3.5538 4.99893L3.362 4.89822L3.1702 4.99893L3.20682 4.78543L3.05164 4.63419L3.26596 4.60297L3.362 4.40869Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18951 4.40869L4.28555 4.60297L4.49988 4.63419L4.3447 4.78543L4.38132 4.99893L4.18951 4.89822L3.99771 4.99893L4.03433 4.78543L3.87915 4.63419L4.09357 4.60297L4.18951 4.40869Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01727 4.40869L5.11322 4.60297L5.32755 4.63419L5.17245 4.78543L5.20908 4.99893L5.01727 4.89822L4.82547 4.99893L4.86209 4.78543L4.70691 4.63419L4.92123 4.60297L5.01727 4.40869Z",
    fill: "#ECF0F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2384_121675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlagIcon);
export default __webpack_public_path__ + "static/media/us-flag-icon.f7782cb2617f5a84c14f17fb01bdc40a.svg";
export { ForwardRef as ReactComponent };